// extracted by mini-css-extract-plugin
export var GalleryImage = "GalleryImage-module--GalleryImage--tfxON";